<div class = "folder-list">
  <div class="folder-wrapper" style="margin-right:10px;">
    <ion-skeleton-text class="folder-icon" animated></ion-skeleton-text>
    <div style="margin-top: 25px">
      <ion-skeleton-text class="folder-name" animated></ion-skeleton-text>
      <!--      <ion-skeleton-text class="folder-title" animated></ion-skeleton-text>-->
    </div>
  </div>
  <div class="folder-wrapper">
    <ion-skeleton-text class="folder-icon" animated></ion-skeleton-text>
    <div style="margin-top: 25px">
      <ion-skeleton-text class="folder-name" animated></ion-skeleton-text>
      <!--      <ion-skeleton-text class="folder-title" animated></ion-skeleton-text>-->
    </div>
  </div>
</div>
